import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

import type { TwoColumnRowProps } from './TwoColumnRow';

export const useCustomStyles = makeStyles<Pick<TwoColumnRowProps, 'contentColumnRatio' | 'centerOrFlexStart'>>()(
	(theme, { contentColumnRatio = 6, centerOrFlexStart = 'center' }) => ({
		twoColumnRow: {
			display: 'flex',
			borderBottom: theme.divider.border,
			padding: `${theme.spacing.small} 0`,
			flexDirection: 'column',
			gap: theme.spacing.xsmall,

			[getFromBreakpoint('md')]: {
				flexDirection: 'row',
				gap: theme.spacing.medium,
				alignItems: centerOrFlexStart,
			},
		},
		titleContainer: {
			flex: '1',
		},
		title: {
			color: theme.palette.neutral[50],
		},
		cellContentContainer: {
			flex: `${contentColumnRatio}`,
			color: theme.palette.neutral[60],
		},
	}),
);
